import { TestObject } from "src/app/models/testObject";
import { GraphQLTestObjectOutput } from "../models/output/graphql-test-object-output";

export function convertGraphqlTestObjectToTestObject(input: GraphQLTestObjectOutput): TestObject {
    return {
      uid: input.Uid,
      name: input.Name
    }
  }